import { FORBIDDEN_USERNAME_WORDS } from "./forbiddenUsernameWords";

export const validatePassword = (password: string) => {
    // Minimum eight characters
    const lengthCheck = password.length >= 8 && password.length <= 120;

    // Check for variety of character types
    const checks = [
        /[A-Z]/.test(password), // Uppercase Letter
        /[a-z]/.test(password), // Lowercase Letter
        /[0-9]/.test(password), // Digit
        /[^A-Za-z0-9]/.test(password), // Special Character
    ];

    // Count how many types of characters are present
    const trueCounts = checks.filter(Boolean).length;

    // Pass if length is sufficient and at least 2 types of characters are present
    const passed = lengthCheck && trueCounts >= 2;

    return passed
};

const findForbiddenWord = (username: string): string | undefined =>
    FORBIDDEN_USERNAME_WORDS.find((word) => username.toLowerCase().includes(word.toLowerCase()));

// Returns the specific validation error message for a username, or null if valid.
// Forbidden-word matches are wrapped in **double asterisks** for the UI to render as bold.
export const getUsernameValidationError = (username: string): string | null => {
    if (username.length < 6 || username.length > 24) {
        return "Användarnamnet måste vara mellan 6 och 24 tecken långt.";
    }

    if (!/^[A-Za-z0-9äöåÄÖÅ_-]+$/.test(username)) {
        return "Användarnamnet får bara innehålla bokstäver, siffror, understreck (_) och bindestreck (-).";
    }

    const forbiddenWord = findForbiddenWord(username);
    if (forbiddenWord) {
        return `Användarnamnet får inte innehålla ordet "**${forbiddenWord}**".`;
    }

    return null;
};
